export const EDITABLE_MESSAGE_TYPE = 'TEXT';

export function isOwnMessage(message, currentMemberId) {
  const mine = currentMemberId == null ? '' : String(currentMemberId);
  const sender = message?.senderMemberId == null ? '' : String(message.senderMemberId);
  return Boolean(mine) && mine === sender;
}

export function isRevokedMessage(message) {
  return String(message?.status || '').toUpperCase() === 'REVOKED' || Boolean(message?.revokedAt);
}

export function canShowMessageEditAction({ message, currentMemberId, writable }) {
  if (!writable) return false;
  if (!message?.serverMessageId) return false;
  if (!isOwnMessage(message, currentMemberId)) return false;
  if (String(message.messageType || '') !== EDITABLE_MESSAGE_TYPE) return false;
  if (isRevokedMessage(message)) return false;
  return true;
}

export function trimmedEditText(text) {
  return String(text ?? '').trim();
}

export function canSubmitEdit(draft) {
  return Boolean(trimmedEditText(draft));
}

export function mentionMemberIdsOf(message) {
  if (!Array.isArray(message?.mentions)) return [];
  return message.mentions
    .map((row) => (row?.memberId == null || row.memberId === '' ? '' : String(row.memberId)))
    .filter(Boolean);
}
